(() => {
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const refreshCartCount = async () => {
    try {
      const response = await fetch(root() + 'cart.js', {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-rg-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
        node.hidden = cart.item_count === 0;
      });
    } catch (_) {
      // The native cart flow remains available if the request is interrupted.
    }
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-rg-sort]')) {
      event.target.form?.submit();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-rg-quick-add]');
    if (!form || !window.fetch) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;

    const defaultLabel = button.dataset.defaultLabel || button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.loadingLabel || 'Додаємо…';

    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('Unable to add item');
      button.textContent = button.dataset.addedLabel || 'Додано';
      await refreshCartCount();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = defaultLabel;
      }, 1200);
    } catch (_) {
      button.disabled = false;
      button.textContent = defaultLabel;
      form.submit();
    }
  });

  document.addEventListener('click', (event) => {
    const heart = event.target.closest('[data-rg-heart]');
    if (!heart) return;
    const pressed = heart.getAttribute('aria-pressed') === 'true';
    heart.setAttribute('aria-pressed', String(!pressed));
  });

  ['cart:updated', 'cart:refresh'].forEach((name) => {
    document.addEventListener(name, refreshCartCount);
  });
})();
